import React from "react";
import { createController } from "./monaco-controller";
import { Tree } from "./monaco-utils";


class MonacoTree extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			directory: this.props.directory
		};
		
		// This bind is critical for eventlistener and onLayout!!
		this.onLayout = this.onLayout.bind(this);

		this.container = null;
	}


	componentDidMount() {
		this.ensureTree();
		this.tree.model.setInput(this.props.directory);
		this.tree.model.onDidSelect((e) => {
			if (e.selection.length) {
				this.props.onClickFile(e.selection[0]);
			}
		});
		// document.addEventListener("layout", this.onLayout);
		// This is for FlexLayout event
		document.addEventListener('ide_layout_updated', this.onLayout);
	}

	componentWillUnmount() {
		// document.removeEventListener("layout", this.onLayout);
		// This is for FlexLayout event
		document.removeEventListener("ide_layout_updated", this.onLayout);
	}


	componentWillReceiveProps(nextProps) {
		// console.log("monaco-tree, CWRP; props, nextProps: ", this.props, nextProps);

		if (this.state.directory !== nextProps.directory) {
			this.tree.model.setInput(nextProps.directory);
			this.setState({ directory: nextProps.directory });
		} else {
			this.tree.model.refresh();
			// Commented out, becuase if anyfile is opened the tree expand itself!!
			// this.expandTree(this.tree);
		}

	}


	setContainer(container) {
		if (container == null) { return; }
		this.container = container;
	}

	ensureTree() {
		if (this.container.lastChild) {
			this.container.removeChild(this.container.lastChild);
		}

		const { treeConfig, getActions } = this.props;

		treeConfig.controller = createController(this, getActions, true);

		this.tree = new Tree(this.container, treeConfig);
	}


	expandTree(tree) {
		const model = tree.model;
		const elements = [];

		let item;
		const nav = model.getNavigator();

		while (item = nav.next()) {
			elements.push(item);
		}

		for (let i = 0, len = elements.length; i < len; i++) {
			model.expand(elements[i]);
		}
	}


	onLayout() {
		this.tree.layout();
	}


	render() {
		return (
			<div className="fill" ref={(ref) => this.setContainer(ref)}>
			</div>
		)
	}
}


export { MonacoTree }
